/**
 * Created by bzm on 2016/01/04.
 */
'use strict';
angular.module("fragmentServiceModule", ["operateRecordModule", "historyVersionModule"]).factory("fragmentService", ["$modal", "$q", "$timeout", "trsHttpService", "modalDialog", function($modal, $q, $timeout, trsHttpService, modalDialog) {
    var TimingLocker;
    //稿件解锁方法
    function normalLock(tempid) {
        var defer = $q.defer();
        var params = {
            "serviceid": "mlf_exttemplate",
            "methodname": "unLockWidget",
            'TempId': tempid,
        };
        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "post").then(function(data) {
            $timeout.cancel(TimingLocker);
            defer.resolve(data);
        });
        return defer.promise;
    }
    //强制解锁
    function forceDeblocking(item) {
        var defer = $q.defer();
        var params = {
            "serviceid": "mlf_exttemplate",
            "methodname": "forcedUnLockWidget",
            'TempId': item.TEMPID,
        };
        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "post").then(function(data) {
            defer.resolve(data);
        });
        return defer.promise;
    }
    //锁定稿件
    function lockDraft(tempid) {
        // $timeout.cancel(TimingLocker);
        var params = {
            "serviceid": "mlf_exttemplate",
            "methodname": "lockWidget",
            'TempId': tempid,
        };
        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "post", true);
        /*.then(function(data) {
            TimingLock(tempid);
        }, function() {
            TimingLock(tempid);
        });*/
    }

    /*//30s定时加锁
    function TimingLock(tempid) {
        TimingLocker = $timeout(function() {
            lockDraft(tempid);
        }, 30000);
    }*/
    return {
        getNowTime: function() {
            var date = new Date();
            var seperator1 = "-";
            var seperator2 = ":";
            var month = date.getMonth() + 1;
            var strDate = date.getDate();
            if (month >= 1 && month <= 9) {
                month = "0" + month;
            }
            if (strDate >= 0 && strDate <= 9) {
                strDate = "0" + strDate;
            }
            var currentdate = date.getFullYear() + seperator1 + month + seperator1 + strDate + " " + date.getHours() + seperator2 + date.getMinutes();
            return currentdate;
        },
        operateRecord: function(tempId) {
            var modalInstance = $modal.open({
                templateUrl: "./editingCenter/website/fragmentManagement/service/operateRecord/operateRecord_tpl.html",
                windowClass: 'operateRecord-window',
                backdrop: false,
                controller: "operateRecordCtrl",
                resolve: {
                    params: function() {
                        return {
                            tempId: tempId
                        };
                    }
                }
            });
            modalInstance.result.then(function(result) {});
        },
        historyVersion: function(widgetParams) {
            var modalInstance = $modal.open({
                templateUrl: "./editingCenter/website/fragmentManagement/service/historyVersion/historyVersion_tpl.html",
                windowClass: 'historyVersion-window',
                backdrop: false,
                controller: "historyVersionCtrl",
                resolve: {
                    widgetParams: function() {
                        return widgetParams;
                    }
                }
            });
            modalInstance.result.then(function(result) {});
        },
        getDocIds: function(DataJson) {
            var docIdsObj = {};
            var docIds = "";
            try {
                for (var i = 0; i < DataJson.length; i++) {
                    var DataJsonObj = DataJson[i];
                    var DataJson_ = DataJsonObj.content;
                    if (DataJsonObj.type !== "docs") {
                        for (var j = 0; j < DataJson_.length; j++) {
                            if (angular.isDefined(DataJson_[j].metadataId)) {
                                docIdsObj[DataJson_[j].metadataId] = true;
                            }
                        }
                    } else {
                        for (var k = 0; k < DataJson_.length; k++) {
                            var DataJson__ = DataJson_[k];
                            for (var l = 0; l < DataJson__.length; l++) {
                                if (angular.isDefined(DataJson__[l].metadataId)) {
                                    docIdsObj[DataJson__[l].metadataId] = true;
                                }
                            }
                        }
                    }
                }
                for (var m in docIdsObj) {
                    docIds += (m + ",");
                }
                //docIds.length = docIds.length - 1;
                docIds = docIds.substring(0, docIds.length - 1)
            } catch (e) {
                docIds = "";
                console.log(e);
                console.log("处理碎片化稿件IDS异常");
            } finally {
                return docIds;
            }
        },
        //判断碎片化稿件是否被锁
        isLock: function(item, siteid) {
            var defer = $q.defer();
            var params = {
                "serviceid": "mlf_exttemplate",
                "methodname": "checkWidgetIsLock",
                'TempId': item.TEMPID,
                'SiteId': siteid
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "post").then(function(data) {
                defer.resolve(data);
            });
            return defer.promise;
        },
        //正常解锁碎片化稿件
        normalLock: function(tempid) {
            var deffer = $q.defer();
            normalLock(tempid).then(function(data) {
                deffer.resolve(data);
            });
            return deffer.promise;
        },
        //锁定碎片化稿件
        lockDraft: function(tempid) {
            lockDraft(tempid);
        },
        //碎片化稿件解锁权限校验
        checkUnlockPermissions: function(item, data) {
            var deffer = $q.defer();
            if (angular.isDefined(data.ISHASRIGHT) && data.ISHASRIGHT === "true") {
                modalDialog.alertType("碎片化稿件已经被【" + data.LOCKUSER + "】锁定,是否强制解锁", "", "warning", true, function() {
                    forceDeblocking(item).then(function(data) {
                        deffer.resolve();
                    });
                }, function() {
                    deffer.reject();
                });
            } else {
                modalDialog.alertType("碎片化稿件已经被【" + data.LOCKUSER + "】锁定", "", "warning","confirm",function(){
                    deffer.reject();
                });
            }
            return deffer.promise;
        },
        cancelTimingLock: function() {
            $timeout.cancel(TimingLocker);
        }
    };
}]);